<script setup lang="ts">
import ContactsBlock from '@/client/components/blocks/ContactsBlock.vue';
import FaqBlock from '@/client/components/blocks/FaqBlock.vue';
import HeroBlock from '@/client/components/blocks/HeroBlock.vue';
import LeadFormBlock from '@/client/components/blocks/LeadFormBlock.vue';
import ProductsBlock from '@/client/components/blocks/ProductsBlock.vue';
import TextBlock from '@/client/components/blocks/TextBlock.vue';
import type { ContactsContent, FaqContent, HeroContent, LeadFormContent, ProductsContent, TextContent } from '@/client/types';

/**
 * A landing section by its type; the content shape is set by App\Enums\LandingBlockType::fields().
 * The call to action leads to the request form when the page has one.
 */
defineProps<{
    block: App.Data.SiteBlockData;
    ctaHref?: string | null;
    captcha?: App.Data.CaptchaWidgetData | null;
    privacyUrl?: string;
    offerUrl?: string;
    /** The products the site shows: the products section and the choice in the request form. */
    products?: App.Data.SiteProductData[];
    /** "How did you hear about us" in the request form. */
    sources?: { id: number; name: string }[];
}>();
</script>

<template>
    <HeroBlock v-if="block.type === 'hero'" :id="block.key" :content="block.content as HeroContent" :cta-href="ctaHref" />
    <TextBlock v-else-if="block.type === 'text'" :id="block.key" :content="block.content as TextContent" />
    <ProductsBlock v-else-if="block.type === 'products'" :id="block.key" :content="block.content as ProductsContent" :products="products ?? []" />
    <FaqBlock v-else-if="block.type === 'faq'" :id="block.key" :content="block.content as FaqContent" />
    <LeadFormBlock
        v-else-if="block.type === 'lead_form'"
        :id="block.key"
        :content="block.content as LeadFormContent"
        :captcha="captcha ?? null"
        :privacy-url="privacyUrl ?? '#'"
        :offer-url="offerUrl ?? '#'"
        :products="products ?? []"
        :sources="sources ?? []"
    />
    <ContactsBlock v-else-if="block.type === 'contacts'" :id="block.key" :content="block.content as ContactsContent" />
</template>
